module.exports = __webpack_public_path__ + "static/img/female-bg-tr.97ce7cc5.png";